import { PureComponent } from 'react'
import { environment } from '../../../../environment'
import PropTypes from 'prop-types'

class OAuth extends PureComponent {

  getOAuthUrl (state) {
    state.id = this.generateRandomString()
    const stateBase64 = this.b64EncodeUnicode(JSON.stringify(state))
    let url = {
      path: environment.CONFIG_OAUTH_BASE_URL + '/oauth2/auth',
      query: [
        ['client_id', environment.CONFIG_OAUTH_CLIENT_ID],
        ['max_age', '0'],
        ['nonce', this.generateRandomString()],
        ['redirect_uri', environment.CONFIG_OAUTH_REDIRECT_URI],
        ['response_type', 'id_token'],
        ['scope', 'openid email'],
        ['state', stateBase64]
      ]
    }
    let queryString = ''
    for (let p of url.query) {
      if (queryString === '') {
        queryString += '?'
      } else {
        queryString += '&'
      }
      p[1] = encodeURIComponent(p[1])
      queryString += p.join('=')
    }
    return url.path + queryString
  }

  generateRandomString () {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  }

  b64EncodeUnicode (str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
    }))
  }

  render () {
    const state = {
      from: [
        this.props.from.pathname, this.props.from.search, this.props.from.hash
      ].join(''),
    }
    window.location.href = this.getOAuthUrl(state)
    return null
  }
}

OAuth.propTypes = {
  from: PropTypes.object.isRequired
}
export default OAuth
